import { Injectable } from "@angular/core";
import detectEthereumProvider from "@metamask/detect-provider";
import { History } from "../models";
import { environment } from "environments/environment";

import { BehaviorSubject, from, Observable } from "rxjs";

const Web3 = require("web3");

declare let require: any;
declare let window: any;
const tokenAbi = require("../abi/abis.js");

@Injectable({
  providedIn: "root",
})
export class ContractService {
  account$ = new BehaviorSubject<any>("");
  public account: any = null;
  web3: any;
  transferContract: any;
  transferContract$ = new BehaviorSubject<any[]>([]);
  private enable: any;
  readonly address = tokenAbi.uDonate_address;
  public chainId$ = new BehaviorSubject<any>({});
  private provider: any;

  constructor() {
    window.web3 = new Web3(window.ethereum);
    if (window.ethereum === undefined) {
      alert("Non-Ethereum browser detected. Install MetaMask");
    } else {
      this.web3 = window.web3;
    }

    this.getChainId().subscribe(
      (result) => this.getChainName(),
      (error) => console.log(error)
    );

    this.connect();
  }

  connect() {
    this.changeChain();
    if (this.web3) {
      this.getWallet();
    }
    this.setAccount();
    this.setContract();

    this.correctChain();
  }

  /**
   * Get Account number
   * @returns Promise<string>
   */
  private getWallet(): void {
    const enable = from(window.ethereum.enable());
    enable.subscribe(
      (result) => (this.enable = result),
      (error) => console.log(error)
    );
  }

  public setAccount(): void {
    from(this.web3.eth.getAccounts()).subscribe(
      (data) => {
        this.account = data;
        this.account$.next(this.account);
      },
      (error) => console.log(error)
    );
  }

  correctChain(): void {
    from(window.ethereum.request({ method: "eth_chainId" })).subscribe(
      (result) => this.chainId$.next(result),
      (error) => console.log(error)
    );
  }

  getChainName(): string {
    switch (this.chainId$.value) {
      case "0x3":
        return "Ropsten";
      case "0x61":
        return "BSC Testnet";
      case "0x38":
        return "Binance Smart Chain";
      default:
        return "Network not Accepted";
    }
  }

  getChainId(): Observable<string> {
    return this.chainId$.asObservable();
  }

  getChain(): any {
    switch (this.chainId$.value) {
      case "0x3":
        return {
          name: "Ropsten Testnet",
          url: "https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
          network: "3",
          port: "-",
        };
      case "0x61":
        return {
          name: "BSC - Binance Smart Chain TestNet",
          url: "https://data-seed-prebsc-1-s1.binance.org/",
          network: "97",
          port: "8545",
        };
      case "0x38":
        return {
          name: "BSC - Binance Smart Chain",
          url: "https://bsc-dataseed.binance.org/",
          network: "56",
          port: "-",
        };
      default:
        return {};
    }
  }

  setContract() {
    //const correctChain = await this.correctChain();

    //if (!correctChain) return false;

    //this.provider = await detectEthereumProvider();

    this.transferContract = new this.web3.eth.Contract(
      tokenAbi.uDonate_abi,
      tokenAbi.uDonate_address,
      {
        gas: 3000000,
      }
    );
    //await this.transferContract.setProvider(this.web3.currentProvider);

    this.transferContract$.next(this.transferContract);
    //return Promise.resolve(true);
  }

  public changeChain() {
    console.log("change");
    try {
      from(
        window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: environment.chain.id }], // chainId must be in hexadecimal numbers
        })
      ).subscribe(
        (result) => {
          console.log(result);
        },
        (error) => {
          console.log(error);
          this.addChain();
        }
      );
    } catch (switchError) {
      this.addChain();
    }
  }

  addChain() {
    try {
      console.log("Trying to add RCP...");
      from(
        window.ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: environment.chain.id,
              chainName: environment.chain.name,
              rpcUrls: environment.chain.rpc,
              nativeCurrency: environment.chain.nativeCurrency,
              blockExplorerUrls: environment.chain.blockExplorerUrls,
            },
          ],
        })
      );
    } catch (addError) {
      // handle "add" error
    }
  }

  private async enableMetaMaskAccount(): Promise<any> {
    let enable = false;
    await new Promise((resolve, reject) => {
      enable = window.ethereum.enable();
    });
    return Promise.resolve(enable);
  }

  public getAccount(): Observable<any> {
    return this.account$.asObservable();
  }

  public async getUserBalance(): Promise<any> {
    const account = await this.getAccount();
    return new Promise((resolve, reject) => {
      window.web3.eth.getBalance(account, (err: any, balance: any) => {
        console.log("transfer.service :: getUserBalance :: getBalance");
        console.log(balance);
        if (!err) {
          const retVal = {
            account,
            balance,
          };
          console.log(
            "transfer.service :: getUserBalance :: getBalance :: retVal"
          );
          console.log(retVal);
          resolve(retVal);
        } else {
          reject({ account: "error", balance: 0 });
        }
      });
    }) as Promise<any>;
  }

  async getBlockTimestamp(block: number) {
    const timestamp = await this.web3.eth.getBlock(block);
    return timestamp.timestamp;
  }

  owner(): Observable<any> {
    const owner = this.transferContract.methods
      .owner()
      .call({ from: this.account$.value[0] });

    return from(owner);
  }

  /**
   * Safe Mint
   *
   * @dev create a token on blockchain to the selected account
   * permission - only owner
   * +Send+
   *
   * - tokenId is the token will be register on the blockchain
   * - @todo Need tell the account will be owner of token
   */
  async safeMint(tokenId: number) {
    const account = await this.account$.value[0]();
    const accounts = await this.web3.eth.getAccounts();

    return this.transferContract.methods
      .safeMint(account, tokenId)
      .send({ from: accounts[0] })
      .then((data: any) => {
        console.log(account);
        return { data, account };
      });
  }

  /**
   * Get owner of Token
   *
   * @dev Return the account that is owner of a token
   * permission - anyone
   * +Call+
   *
   * - tokenId is the token registered on the blockchain
   */
  ownerOf(tokenId: string): Observable<any> {
    const owner = this.transferContract.methods
      .ownerOf(tokenId)
      .call({ from: this.account$.value[0] });

    return from(owner);
  }

  async transferFrom(from: string, to: string, tokenId: number) {
    const accounts = await this.web3.eth.getAccounts();

    return this.transferContract.methods
      .transferFrom(from, to, tokenId)
      .send({ from: accounts[0] })
      .then((data: any) => {
        return data;
      });
  }

  transferEther(value: { transferAddress: string; amount: string }) {
    const that = this;
    console.log(
      "transfer.service :: transferEther to: " +
        value.transferAddress +
        ", from: " +
        that.account +
        ", amount: " +
        value.amount
    );
    return new Promise((resolve, reject) => {
      console.log("transfer.service :: transferEther :: tokenAbi");
      console.log(tokenAbi);

      // OLD
      // const contract = require('@truffle/contract');
      // const transferContract = contract(tokenAbi);

      const transferContract = this.web3.eth.Contract(tokenAbi, this.address, {
        gas: 3000000,
      });
      transferContract.setProvider(that.web3);
      console.log("transfer.service :: transferEther :: transferContract");
      console.log(transferContract);
      transferContract
        .deployed()
        .then(
          (instance: {
            pay: (arg0: string, arg1: { from: any; value: string }) => any;
          }) => {
            return instance.pay(value.transferAddress, {
              from: that.account,
              value: value.amount,
            });
          }
        )
        .then((status: any) => {
          if (status) {
            return resolve({ status: true });
          }
        })
        .catch((error: any) => {
          console.log(error);
          return reject("transfer.service error");
        });
    });
  }

  /* ASSET FUNCTIONS */
  /**
   * Mint an Asset on Blockchain
   *
   * @dev Create an Asset
   * permission - anyone
   * +Send+
   *
   * - Send Asset Info to Blockchain
   */
  async mintAsset(asset: any) {
    return this.transferContract.methods
      .mintAsset(this.account[0], asset)
      .send({ from: this.account[0] })
      .then((data: any) => {
        return data;
      });
  }

  /**
   * Get an Asset
   *
   * @dev Return an Asset
   * permission - anyone
   * +Call+
   *
   * - Get The asset Info
   */
  async getAsset(tokenId: string) {
    return this.transferContract.methods
      .getAsset(tokenId)
      .call({ from: this.account$.value[0] })
      .then((data: any) => {
        return data;
      });
  }

  /**
   * Get an Asset Event(AttachInfo)
   *
   * @dev Return Asset info
   * +Event+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *              this.getAttachInfoEvent('0xEf33fA1Ff1895f5690537Ca458520Eb94172Ea1A')
   *          </caption>
   * @returns Promise<any>
   */
  async getAttachInfoEvent(tokenId: any = null) {
    return await this.transferContract
      .getPastEvents(
        "AttachInfo",
        {
          filter: {}, // Using an array means OR: e.g. 20 or 23
          fromBlock: 0,
          toBlock: "latest",
        },
        (error: any, events: any) => console.log(events)
      )
      .then((events: any) => events);
  }

  /**
   * Get Token Event(Transfer)
   *
   * @dev Return Asset info
   * +Event+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *              this.getTransferEvent('0xEf33fA1Ff1895f5690537Ca458520Eb94172Ea1A')
   *          </caption>
   * @returns Promise<any>
   */
  async getTransferEvent(
    tokenId: any = null,
    from: any = null,
    to: any = null
  ): Promise<any> {
    const filter = this.prepareFilter({ tokenId, from, to });

    console.log(filter);

    return await this.transferContract
      .getPastEvents(
        "Transfer",
        {
          filter: {}, // Using an array means OR: e.g. 20 or 23
          fromBlock: 0,
          toBlock: "latest",
        },
        (error: any, events: any) => console.log(events)
      )
      .then((events: any) => events);
  }

  /* USER functions */
  /**
   * Create an User
   *
   * @dev Create an User
   * permission - msgSender
   * +Send+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *          this.createUser(['Bank Name', 'Street'])
   *          </caption>
   * @returns Promise<any>
   */
  createUser(user: any) {
    const newUser = this.transferContract.methods
      .createUser(user)
      .send({ from: this.account$.value[0] });

    return from(newUser);
  }

  createProxyUser(account: string, user: any) {
    const newUser = this.transferContract.methods
      .proxyCreateUser(account, user)
      .send({ from: this.account$.value[0] });

    return from(newUser);
  }

  /**
   * Get an User
   *
   * @dev Return an User
   * permission - anyone
   * +Call+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *              this.createUser('0xEf33fA1Ff1895f5690537Ca458520Eb94172Ea1A')
   *          </caption>
   * @returns Promise<any>
   */
  getUser(account: any): Observable<any> {
    console.log(this.account$.value);
    const user = this.transferContract.methods
      .getUser(account)
      .call({ from: this.account$.value[0] });

    return from(user);
  }

  userPendingList(): Observable<any> {
    const user = this.transferContract.methods
      .userPendingList()
      .call({ from: this.account$.value[0] });

    return from(user);
  }

  approveUser(account: string): Observable<any> {
    const user = this.transferContract.methods
      .approveUser(account)
      .send({ from: this.account$.value[0] });

    return from(user);
  }

  /**
   * Get an User Events
   *
   * @dev Return an User Changes
   * permission - anyone
   * +Event+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *              this.createUser('0xEf33fA1Ff1895f5690537Ca458520Eb94172Ea1A')
   *          </caption>
   * @returns Promise<any>
   */
  getUserEvent(account: any): Observable<any> {
    const event = this.transferContract
      .getPastEvents("CreateUser", {
        filter: { account }, // Using an array means OR: e.g. 20 or 23
        fromBlock: 0,
        toBlock: "latest",
      })
      .then((events: any) => {
        return events;
      });

    return from(event);
  }

  /* History functions */
  /**
   * Register a token history
   *
   * permission - owner
   * +Send+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *          this.createHistory(
   *              0x555d6c3369ca37f820850e4cf253cd1134057a80a5283172e36e966f2bf322cf,
   *              ['1999-12-25', 'Any note'])
   *          </caption>
   * @returns Promise<any>
   */
  createHistory(tokenId: string, history: History): Observable<any> {
    const hist = this.transferContract.methods
      .setHistory(tokenId, history)
      .send({ from: this.account[0] });

    return from(hist);
  }

  /**
   * Get the History of the Token
   *
   * permission - whitelisted
   * +Call+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *          this.getHistory(
   *              0x555d6c3369ca37f820850e4cf253cd1134057a80a5283172e36e966f2bf322cf,
   *              ['1999-12-25', 'Any note'])
   *          </caption>
   * @returns Promise<any>
   */
  getHistory(tokenId: string): Observable<any> {
    const history = this.transferContract.methods
      .getHistory(tokenId)
      .call({ from: this.account[0] });

    return from(history);
  }

  /* Transaction Functions */
  /**
   * Prepare Transaction
   *
   * @dev Prepare a token Transfer
   * permission - owner or approved
   * +Send+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *          this.prepareTransaction([
   *              '0x0003fA1Ff1895f5690537Ca458520Eb94172Ea1A',
   *              '0x9999fA1Ff1895f5690537Ca458520Eb94172Ea1A',
   *              '0x555d6c3369ca37f820850e4cf253cd1134057a80a5283172e36e966f2bf322cf',
   *              'Message'
   *          ])
   *          </caption>
   * @returns Promise<any>
   */
  prepareTransaction(transfer: any): Observable<any> {
    console.log(transfer);

    const transf = this.transferContract.methods
      .prepareTransfer(
        transfer.from,
        transfer.to,
        transfer.tokenId,
        transfer.message,
        transfer.finalDate,
        transfer.rollbackDate,
        transfer.code
      )
      .send({ from: this.account[0] });

    return from(transf);
  }

  /**
   * TransferStatus
   *
   * @dev Get Transfer Status
   * permission - To, (from or approved)
   * +Send+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *          this.transferStatus([
   *              '0x555d6c3369ca37f820850e4cf253cd1134057a80a5283172e36e966f2bf322cf',
   *          ])
   *          </caption>
   * @returns Observable<any>
   */
  transferStatus(transferId: string): Observable<any> {
    const transfer = this.transferContract.methods
      .transferStatus(transferId)
      .call({ from: this.account$.value[0] });

    return from(transfer);
  }

  tokenTransfers(tokenId: string): Observable<any> {
    const transferList = this.transferContract.methods
      .tokenTransfers(tokenId)
      .call({ from: this.account$.value[0] });

    return from(transferList);
  }

  async acceptTransfer(tokenId: string) {
    return this.transferContract.methods
      .acceptTransfer(tokenId)
      .send({ from: this.account[0] })
      .then((data: any) => {
        return data;
      });
  }

  async rejectTransfer(tokenId: string, message: string) {
    return this.transferContract.methods
      .rejectTransfer(tokenId, message)
      .send({ from: this.account[0] })
      .then((data: any) => {
        return data;
      });
  }

  async sendTransfer(tokenId: string) {
    return this.transferContract.methods
      .sendTransfer(tokenId)
      .send({ from: this.account[0] })
      .then((data: any) => {
        return data;
      });
  }

  async getPreTransferEvent(
    transferId: string = null,
    tokenId: string = null,
    to: string = null,
    from: string = null,
    sender: string = null,
    status: string = null
  ) {
    const filter = this.prepareFilter({
      transferId,
      tokenId,
      to,
      from,
      sender,
      status,
    });

    console.log("filter:", filter);

    return await this.transferContract
      .getPastEvents(
        "PreTransfer",
        {
          filter, // Using an array means OR: e.g. 20 or 23
          fromBlock: 0,
          toBlock: "latest",
        },
        (error: any, events: any) => console.log(events)
      )
      .then((events: any) => {
        console.log(events);
        return events;
      });
  }

  getPreTransferEvent2(
    transferId: string = null,
    tokenId: string = null,
    to: string = null,
    from: string = null,
    sender: string = null,
    status: string = null
  ): Observable<any> {
    const filter = this.prepareFilter({
      transferId,
      tokenId,
      to,
      from,
      sender,
      status,
    });

    const event = this.transferContract.getPastEvents(
      "PreTransfer",
      { filter, fromBlock: 0, toBlock: "latest" },
      (error: any, events: any) => console.log(events)
    );

    console.log(event);

    return event;
  }

  /* Whitelist Functions */
  /**
   * Set Address to Token Whitelist
   *
   * permission - Onwer or Authorized
   * +Send+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *          this.setWhitelist(
   *              0x555d6c3369ca37f820850e4cf253cd1134057a80a5283172e36e966f2bf322cf,
   *              0xEf33fA1Ff1895f5690537Ca458520Eb94172Ea1A,
   *              3)
   *          </caption>
   * @returns Promise<any>
   */
  setWhitelist(
    tokenId: string,
    account: string,
    permission: number
  ): Observable<any> {
    const whitelist = this.transferContract.methods
      .setWhitelist(tokenId, account, permission)
      .send({ from: this.account[0] }, (error: any, transactionHash: any) => {
        console.log(error, transactionHash);
      });

    return from(whitelist);
  }

  /**
   * Get Permission
   *
   * permission - Onwer or Sender
   * +Call+
   *
   * @author Bruno Oliveira <bruno@awdd.com.br>
   * @example <caption>
   *          this.getWhitelist(
   *              0x555d6c3369ca37f820850e4cf253cd1134057a80a5283172e36e966f2bf322cf,
   *              0xEf33fA1Ff1895f5690537Ca458520Eb94172Ea1A)
   *          </caption>
   * @returns Promise<any>
   */
  getWhitelist(tokenId: string, account: string) {
    const whitelist = this.transferContract.methods
      .getWhitelist(tokenId, account)
      .call({ from: this.account[0] });

    return from(whitelist);
  }

  async signature() {
    const chainId = parseInt(this.chainId$.value, 16);
    const msgParams = {
      domain: {
        chainId: chainId.toString(),
        name: "Ether Mail",
        verifyingContract: "0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC",
        version: "1",
      },
      message: {
        contents: "Hello, Bob!",
        from: {
          name: "Cow",
          wallets: [
            "0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826",
            "0xDeaDbeefdEAdbeefdEadbEEFdeadbeEFdEaDbeeF",
          ],
        },
        to: [
          {
            name: "Bob",
            wallets: [
              "0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB",
              "0xB0BdaBea57B0BDABeA57b0bdABEA57b0BDabEa57",
              "0xB0B0b0b0b0b0B000000000000000000000000000",
            ],
          },
        ],
      },
      primaryType: "Mail",
      types: {
        EIP712Domain: [
          { name: "name", type: "string" },
          { name: "version", type: "string" },
          { name: "chainId", type: "uint256" },
          { name: "verifyingContract", type: "address" },
        ],
        Group: [
          { name: "name", type: "string" },
          { name: "members", type: "Person[]" },
        ],
        Mail: [
          { name: "from", type: "Person" },
          { name: "to", type: "Person[]" },
          { name: "contents", type: "string" },
        ],
        Person: [
          { name: "name", type: "string" },
          { name: "wallets", type: "address[]" },
        ],
      },
    };
    try {
      const from = this.account[0];
      const sign = await window.ethereum.request({
        method: "eth_signTypedData_v4",
        params: [from, JSON.stringify(msgParams)],
      });
      console.log(sign);
    } catch (err) {
      console.error(err);
    }
  }

  watchEtherTransfers() {
    // Instantiate subscription object
    const subscription = this.web3.eth.subscribe("pendingTransactions");

    // Subscribe to pending transactions
    subscription
      .subscribe((error: any, result: any) => {
        if (error) console.log(error);
      })
      .on("data", async (txHash: string) => {
        try {
          // Get transaction details
          const trx = await this.web3.eth.getTransaction(txHash);

          const valid = true; //validateTransaction(trx);
          // If transaction is not valid, simply return
          if (!valid) return;

          //console.log('Found incoming Ether transaction from ' + process.env.WALLET_FROM + ' to ' + process.env.WALLET_TO);
          //console.log('Transaction value is: ' + process.env.AMOUNT);
          //console.log('Transaction hash is: ' + txHash + '\n');

          // Initiate transaction confirmation
          this.confirmEtherTransaction(txHash);

          // Unsubscribe from pending transactions.
          subscription.unsubscribe();
        } catch (error) {
          console.log(error);
        }
      });
  }

  async getConfirmations(txHash: any) {
    try {
      // Get transaction details
      const trx = await this.web3.eth.getTransaction(txHash);

      // Get current block number
      const currentBlock = await this.web3.eth.getBlockNumber();

      // When transaction is unconfirmed, its block number is null.
      // In this case we return 0 as number of confirmations
      return trx.blockNumber === null ? 0 : currentBlock - trx.blockNumber;
    } catch (error) {
      console.log(error);
    }
  }

  confirmEtherTransaction(txHash: string, confirmations = 10) {
    setTimeout(async () => {
      // Get current number of confirmations and compare it with sought-for value
      const trxConfirmations: any = await this.getConfirmations(txHash);

      console.log(
        "Transaction with hash " +
          txHash +
          " has " +
          trxConfirmations +
          " confirmation(s)"
      );

      if (trxConfirmations >= confirmations) {
        // Handle confirmation event according to your business logic

        console.log(
          "Transaction with hash " + txHash + " has been successfully confirmed"
        );

        return;
      }
      // Recursive call
      return this.confirmEtherTransaction(txHash, confirmations);
    }, 30 * 1000);
  }

  /**
   * @param {Object} filter
   */
  prepareFilter(filter: any) {
    for (let key of Object.keys(filter)) {
      if (filter[key] == null || undefined || "") delete filter[key];
    }
    return filter;
  }
}
